function animation({ type = "enter", name = "fade", delay = 0, duration = 700, data = {} } = {}) {
  return {
    type,
    name,
    delay,
    duration,
    enabled: true,
    data,
  };
}

export const motionPresets = {
  detailPanelReveal(delay = 100) {
    return [animation({ name: "fade", delay, duration: 700 })];
  },

  detailOrnamentReveal(delay = 450) {
    return [animation({ name: "zoom", delay, duration: 650, data: { direction: "in", strength: 0.18 } })];
  },

  dividerReveal(delay = 550) {
    return [animation({ name: "fade", delay, duration: 600 })];
  },

  detailTextReveal(delay = 700) {
    return [animation({ name: "move", delay, duration: 650, data: { direction: "up", strength: 0.18 } })];
  },

  garlandDrop(delay = 150) {
    return [animation({ name: "move", delay, duration: 1000, data: { direction: "down", strength: 0.35 } })];
  },

  heroReveal(delay = 300) {
    return [animation({ name: "zoom", delay, duration: 1200, data: { direction: "in", strength: 0.35 } })];
  },

  softSparkle(delay = 900) {
    return [animation({ name: "fade", delay, duration: 700 })];
  },

  floorGlowPulse(delay = 0) {
    return [animation({ type: "loop", name: "blink", delay, duration: 2200, data: {} })];
  },

  programBadgePop(delay = 450) {
    return [animation({ name: "zoom", delay, duration: 700, data: { direction: "in", strength: 0.22 } })];
  },

  settledFrameReveal(delay = 350) {
    return [animation({ name: "fade", delay, duration: 900 })];
  },
};
